import { useLingui } from '@lingui/react/macro';
import { type FC, memo } from 'react';
import { ConvertForm } from '@/account/trade/convert/ConvertForm';
import { useConvertParams } from '@/account/trade/convert/useConvertParams';
import { useLocation } from '@/base/router';
import { useCoin } from '@/shared/api';
import { cn } from '@/shared/react';
import { ToggleGroup } from '@/shared/ToggleGroup';
import { Widget } from '@/shared/Widget';

type CoinTradeWidgetProps = {
  slug?: string;
  className?: string;
};

export const CoinTradeWidget: FC<CoinTradeWidgetProps> = memo(
  ({ slug, className }) => {
    const { t } = useLingui();
    const { data: coin } = useCoin(slug?.toUpperCase());
    const params = useConvertParams(coin?.slug || undefined);
    const [, navigate] = useLocation();

    return (
      <Widget className={cn('space-y-4', className)}>
        <header className="space-y-2">
          <p className="text-lg font-medium text-content-primary">
            {params.type === 'buy' ? t`Buy` : t`Sell`} {coin?.name}
          </p>
          <ToggleGroup
            variant="button"
            value={params.type}
            onChange={(next) => params.setType(next as 'buy' | 'sell')}
            options={[
              {
                key: 'buy',
                value: 'buy',
                label: t`Buy`,
              },
              {
                key: 'sell',
                value: 'sell',
                label: t`Sell`,
              },
            ]}
            size={10}
            className="w-full"
          />
        </header>

        <ConvertForm
          type={params.type}
          fromCoin={params.fromCoin}
          onFromCoinChange={params.setFromCoin}
          toCoin={params.toCoin}
          onToCoinChange={params.setToCoin}
          onSuccess={() => {
            navigate('app', '/trade/instant');
          }}
        />
      </Widget>
    );
  },
);
